import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { guid } from '@/mixins/guid';

export default Vue.component('edit-section', {
  template: require('./template.html'),
  mixins: [guid],
  computed: {
    ...mapGetters(['getContentBlocks', 'viewport']),
  },
  data() {
    return {
      loading: false,
      showConfirm: false,
      activeIndex: null,
      initialState: this.getInitialState(),
    };
  },
  props: ['block-index', 'droplet', 'dragging', 'show-edit-bubble'],
  name: 'edit-section',
  methods: {
    setBubbleSize(size) {
      this.$emit('set-bubble-size', size);
    },
    updateId(e) {
      // replace any special chars & white spaces with -
      let hrefId = e.currentTarget.value.replace(/[^a-zA-Z0-9]/g, '-');
      hrefId = _.trim(hrefId);
      const payload = {};
      payload.sec = this.droplet;
      payload.type = 'id';
      payload.error = false;
      payload.hrefId = hrefId === '' ? false : hrefId;
      // check if other section on page has the same id then warn user
      _.forEach(this.getContentBlocks, (block, index) => {
        const id = block.hrefId;
        if (this.blockIndex !== index && id === hrefId && id !== '') {
          payload.error = true;
        }
      });
      this.$store.dispatch('setSectionError', payload);
      this.promise(this.$store.dispatch('setSectionId', payload), 'setting href ID');
    },
    getInitialState() {
      // we use this to replace section on cancel
      return _.cloneDeep(this.droplet);
    },
    setInitialState() {
      this.initialState = this.getInitialState();
    },
    formatErrors(ers) {
      return ers.join(' ');
    },
    promise(action, error) {
      return new Promise((resolve, reject) => {
        if (action) {
          resolve();
        } else {
          reject(Error(`Error in Section: ${error}`));
        }
      });
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/section/components/edit-options/index.js